module.exports = __webpack_public_path__ + "img/car-bolt.1079a67c.svg";